import { Box } from "@mui/material";
import { ArrowRightAlt as ArrowRightAltIcon } from "@mui/icons-material";
import DeletionSnapshot from "./DeletionSnapshot";
import { formatFieldValue } from "../utils/formatFieldValue";

export default function ActivityChange({ entry }) {
  const isLifecycleEvent =
    entry.field === "created" || entry.field === "archived";
  const isCommentDeleted =
    entry.field === "comment" && entry.reason === "Comment deleted";
  const isCommentAdded =
    entry.field === "comment" && entry.reason === "Comment added";
  const isCommentEdited =
    entry.field === "comment" && entry.reason === "Comment edited";
  const isListDiff =
    Array.isArray(entry.oldValue) || Array.isArray(entry.newValue);

  const oldItems = isListDiff ? entry.oldValue || [] : [];
  const newItems = isListDiff ? entry.newValue || [] : [];
  const added = newItems.filter((v) => !oldItems.includes(v));
  const removed = oldItems.filter((v) => !newItems.includes(v));

  const styles = {
    label: { fontWeight: 700 },
    listItem: { pl: 2 },
    arrowIcon: {
      color: "background.text",
      verticalAlign: "middle",
      fontSize: "1.2rem",
    },
  };

  return entry.type === "deletion" ? (
    <DeletionSnapshot reason={entry.reason} snapshot={entry.snapshot} />
  ) : isLifecycleEvent ? (
    entry.reason
  ) : isCommentDeleted ? (
    <Box>
      <Box component="span" sx={styles.label}>
        Deleted Comment
      </Box>{" "}
      {formatFieldValue(entry.oldValue)}
    </Box>
  ) : isCommentAdded ? (
    <Box>
      <Box component="span" sx={styles.label}>
        Added Comment
      </Box>{" "}
      {formatFieldValue(
        Array.isArray(entry.newValue) ? entry.newValue[0] : entry.newValue
      )}
    </Box>
  ) : isCommentEdited ? (
    <Box>
      <Box component="span" sx={styles.label}>
        Changed Comment
      </Box>{" "}
      {formatFieldValue(entry.oldValue)}{" "}
      <ArrowRightAltIcon sx={styles.arrowIcon} />{" "}
      {formatFieldValue(entry.newValue)}
    </Box>
  ) : isListDiff ? (
    added.length === 0 && removed.length === 0 ? (
      "—"
    ) : (
      <>
        {added.length > 0 && (
          <Box>
            <Box component="span" sx={styles.label}>
              Added
            </Box>
            {added.map((item, i) => (
              <Box key={i} sx={styles.listItem}>• {item}</Box>
            ))}
          </Box>
        )}
        {removed.length > 0 && (
          <Box>
            <Box component="span" sx={styles.label}>
              Removed
            </Box>
            {removed.map((item, i) => (
              <Box key={i} sx={styles.listItem}>• {item}</Box>
            ))}
          </Box>
        )}
      </>
    )
  ) : (
    <>
      <Box>
        {formatFieldValue(entry.oldValue)}{" "}
        <ArrowRightAltIcon sx={styles.arrowIcon} />{" "}
        {formatFieldValue(entry.newValue)}
      </Box>
      {entry.message && <Box>{entry.message}</Box>}
    </>
  );
}
